var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBadgeIcon = function SvgBadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 10 2.405 2.191 3.251.152.152 3.252L26 18l-2.192 2.405-.152 3.252-3.25.152L18 26l-2.406-2.191-3.251-.152-.152-3.252L10 18l2.191-2.405.152-3.252 3.25-.152L18 10Zm2.73 5.333-3.772 3.771-1.885-1.885-.629.628 2.515 2.515 4.4-4.4-.63-.629Z",
    fill: "#000"
  }))));
};
export default SvgBadgeIcon;